const UNIX_TIMESTAMP = 1000;

export default UNIX_TIMESTAMP;